export default __webpack_public_path__ + "static/media/submit_report_icon.d8ae0e9a.svg";